export const APP = {
  name: 'KAAMWALA',
  tagline: 'Your Work · Our Responsibility',
  motto: 'Book ⚡ Track ⚡ Get It Done',
  supportPhone: '+919017699977',
};

/**
 * The service verticals shown as the switcher on the home screen and as the
 * "multi service" chooser. Each maps to one or more category groups from the API.
 */
export const VERTICALS = [
  { key: 'all', label: 'All', icon: '🏠', color: '#1B4DE4', group: null },
  { key: 'food', label: 'Food & Grocery', icon: '🛒', color: '#16A34A', group: 'Food, Groceries & Daily Essentials' },
  { key: 'home', label: 'Home Services', icon: '🔧', color: '#0891B2', group: 'Home Services' },
  { key: 'beauty', label: 'Beauty & Fitness', icon: '💇', color: '#DB2777', group: 'Beauty, Fashion & Fitness' },
  { key: 'auto', label: 'Auto & Travel', icon: '🚗', color: '#F97316', group: 'Automobile & Transport' },
  { key: 'shops', label: 'Local Shops', icon: '🏪', color: '#7C3AED', group: 'Local Shops & Stores' },
  { key: 'more', label: 'More', icon: '✨', color: '#0F766E', group: 'Other Services' },
];

export const PARTNER_TYPES = [
  { value: 'shop', label: 'Shop / Store', icon: '🏪', hint: 'Kiryana, chemist, stationery, electronics' },
  { value: 'service_provider', label: 'Service Provider', icon: '🔧', hint: 'Electrician, plumber, cleaning, labour' },
  { value: 'professional', label: 'Professional', icon: '💇', hint: 'Salon, gym, boutique, trainer' },
  { value: 'restaurant', label: 'Food & Restaurant', icon: '🍽️', hint: 'Bakery, juices, street food' },
  { value: 'driver', label: 'Rider / Driver', icon: '🚕', hint: 'Bike taxi, auto, e-rickshaw, taxi or cab' },
  { value: 'courier', label: 'Courier / Pick & Drop', icon: '📦', hint: 'Deliver parcels and documents across the city' },
  { value: 'recruiter', label: 'Recruiter', icon: '💼', hint: 'Post jobs and hire staff' },
  { value: 'vehicle_dealer', label: 'Vehicle Dealer', icon: '🚙', hint: 'Buy and sell vehicles' },
  { value: 'travel_agency', label: 'Tours & Travels', icon: '✈️', hint: 'Packages and travel services' },
  { value: 'event_planner', label: 'Event Planner', icon: '🎉', hint: 'Events and celebrations' },
  { value: 'hospital', label: 'Hospital / Ambulance', icon: '🏥', hint: 'Medical services' },
  { value: 'hotel', label: 'Hotel & Stay', icon: '🏨', hint: 'Rooms and stays' },
  { value: 'animal_seller', label: 'Animal & Bird Seller', icon: '🐄', hint: 'Cows, buffaloes, goats, dogs, birds, poultry, pet food' },
  { value: 'property_dealer', label: 'Property Dealer', icon: '🏠', hint: 'Sell or rent houses, flats, plots and shops' },
  { value: 'other', label: 'Other', icon: '➕', hint: 'Something else' },
];

/** What a rider/driver partner can operate. Courier partners deliver parcels. */
export const VEHICLE_OPTIONS = {
  driver: [
    { value: 'bike', label: '🏍️ Bike taxi', hint: '1 passenger' },
    { value: 'auto', label: '🛺 Auto', hint: 'Up to 3' },
    { value: 'erickshaw', label: '🛺 E-Rickshaw', hint: 'Up to 4' },
    { value: 'taxi', label: '🚖 Taxi', hint: 'Up to 4' },
    { value: 'cab', label: '🚕 Cab', hint: 'Up to 4' },
  ],
  courier: [
    { value: 'courier', label: '📦 Parcel delivery', hint: 'Documents, packages, food' },
  ],
};

export const TIME_SLOTS = [
  '08:00 AM - 10:00 AM',
  '10:00 AM - 12:00 PM',
  '12:00 PM - 02:00 PM',
  '02:00 PM - 04:00 PM',
  '04:00 PM - 06:00 PM',
  '06:00 PM - 08:00 PM',
];

/** What someone can add under "education" on their work profile. */
export const EDUCATION_LEVELS = [
  { value: '10th', label: '10th' },
  { value: '12th', label: '12th' },
  { value: 'diploma', label: 'Diploma' },
  { value: 'iti', label: 'ITI' },
  { value: 'graduate', label: 'Graduate' },
  { value: 'post_graduate', label: 'Post graduate' },
  { value: 'phd', label: 'PhD' },
  { value: 'other', label: 'Other' },
];

/** Job search: what the person has, so they see jobs asking for that or less. */
export const EXPERIENCE_FILTERS = [
  { value: '', label: 'Any experience' },
  { value: '0', label: 'Fresher' },
  { value: '1', label: '1+ year' },
  { value: '3', label: '3+ years' },
  { value: '5', label: '5+ years' },
  { value: '10', label: '10+ years' },
];

export const VEHICLE_BRANDS = ['Hero', 'Honda', 'TVS', 'Bajaj', 'Yamaha', 'Suzuki', 'Royal Enfield', 'KTM', 'Ola', 'Ather', 'Other'];
export const CAR_BRANDS = ['Maruti Suzuki', 'Hyundai', 'Tata', 'Mahindra', 'Honda', 'Toyota', 'Kia', 'Renault', 'Volkswagen', 'Skoda', 'MG', 'Other'];
/** The icon for a saved vehicle. */
export const VEHICLE_ICON = { bike: '🏍️', scooter: '🛵', car: '🚗' };

export const SERVICE_MODES = [
  { value: 'doorstep', label: '🛠️ Doorstep service', hint: 'A mechanic comes to you.' },
  { value: 'pickup_drop', label: '🚚 Pickup & drop', hint: 'We collect the vehicle and bring it back.' },
  { value: 'garage', label: '🏪 At the garage', hint: 'You ride it to the workshop.' },
];

export const SERVICE_SLOTS = ['10:00 AM', '11:00 AM', '12:00 PM', '2:00 PM', '4:00 PM', '6:00 PM'];

/** The stages a service job passes through, as the customer sees them. */
export const SERVICE_STAGES = [
  { value: 'requested', label: 'Booking requested' },
  { value: 'accepted', label: 'Booking confirmed' },
  { value: 'pickup_assigned', label: 'Pickup assigned' },
  { value: 'picked_up', label: 'Vehicle picked up' },
  { value: 'inspection', label: 'Inspection' },
  { value: 'estimate_sent', label: 'Waiting for your approval' },
  { value: 'approved', label: 'Estimate approved' },
  { value: 'in_service', label: 'Service started' },
  { value: 'quality_check', label: 'Quality check' },
  { value: 'ready', label: 'Ready' },
  { value: 'out_for_delivery', label: 'Out for delivery' },
  { value: 'delivered', label: 'Delivered' },
];

export const INSPECTION_PARTS = [
  { value: 'engine', label: 'Engine' },
  { value: 'brake', label: 'Brake' },
  { value: 'tyre', label: 'Tyre' },
  { value: 'battery', label: 'Battery' },
  { value: 'chain', label: 'Chain' },
  { value: 'clutch', label: 'Clutch' },
  { value: 'suspension', label: 'Suspension' },
  { value: 'lights', label: 'Lights' },
  { value: 'electrical', label: 'Electrical' },
  { value: 'oil', label: 'Oil' },
  { value: 'body', label: 'Body condition' },
];

export const HOTEL_AMENITIES = [
  { value: 'wifi', label: '📶 Wi-Fi' },
  { value: 'parking', label: '🚗 Parking' },
  { value: 'restaurant', label: '🍽️ Restaurant' },
  { value: 'ac', label: '❄️ AC' },
  { value: 'lift', label: '🛗 Lift' },
  { value: 'power_backup', label: '🔌 Power backup' },
  { value: 'cctv', label: '📹 CCTV' },
  { value: 'laundry', label: '🧺 Laundry' },
  { value: 'room_service', label: '🛎️ Room service' },
  { value: 'hot_water', label: '🚿 Hot water' },
  { value: 'tv', label: '📺 TV' },
  { value: 'breakfast', label: '🍳 Breakfast' },
];

export const ROOM_TYPES = [
  { value: 'single', label: 'Single' },
  { value: 'double', label: 'Double' },
  { value: 'deluxe', label: 'Deluxe' },
  { value: 'suite', label: 'Suite' },
  { value: 'family', label: 'Family' },
  { value: 'dorm', label: 'Dormitory' },
];

export const NIGHT_PRICES = [
  { value: '', label: 'Any price' },
  { value: '1000', label: 'Under ₹1,000' },
  { value: '2000', label: 'Under ₹2,000' },
  { value: '3500', label: 'Under ₹3,500' },
  { value: '6000', label: 'Under ₹6,000' },
];

export const STAY_RATINGS = [
  { value: '', label: 'Any rating' },
  { value: '3', label: '3★ & up' },
  { value: '4', label: '4★ & up' },
  { value: '4.5', label: '4.5★ & up' },
];

export const SALARY_FILTERS = [
  { value: '', label: 'Any salary' },
  { value: '10000', label: '₹10,000+' },
  { value: '15000', label: '₹15,000+' },
  { value: '20000', label: '₹20,000+' },
  { value: '30000', label: '₹30,000+' },
  { value: '50000', label: '₹50,000+' },
];

export const JOB_TYPES = [
  { value: 'full_time', label: 'Full time' },
  { value: 'part_time', label: 'Part time' },
  { value: 'contract', label: 'Contract' },
  { value: 'internship', label: 'Internship' },
  { value: 'daily_wage', label: 'Daily wage' },
];

export const STATUS_COLORS = {
  placed: '#1B4DE4', requested: '#1B4DE4', accepted: '#4F46E5', preparing: '#D97706',
  ready: '#4F46E5', on_the_way: '#4F46E5', in_progress: '#4F46E5', out_for_delivery: '#4F46E5',
  delivered: '#16A34A', completed: '#16A34A', approved: '#16A34A', paid: '#16A34A',
  cancelled: '#DC2626', rejected: '#DC2626', failed: '#DC2626', pending: '#D97706',
};
